import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs';
import { GenericRequest } from '@core/models/request-status.model';
import { ProductConnector } from '@b2b/features/product/core/services/product.connector';
import { Product } from '@b2b/features/product/core/utilities/product.model';
import {
  getPrice,
  getPriceFail,
  getPriceSuccess,
  getProduct,
  getProductFail,
  getProductSuccess,
  getStock,
  getStockFail,
  getStockSuccess,
} from '@b2b/features/product/core/store/actions/product.actions';
import { Price } from '@b2b/features/product/core/utilities/price.model';
import { GetStockResponse } from '@b2b/features/product/core/utilities/stock.model';

@Injectable()
export class ProductEffects {
  constructor(
    private actions: Actions,
    private productConnector: ProductConnector,
  ) {}

  getProduct$ = createEffect(() => {
    return this.actions.pipe(
      ofType(getProduct),
      mergeMap(({ productID }) => {
        return this.productConnector.getProduct(productID).pipe(
          map((product: GenericRequest<Product>) => {
            if (product.hasError) {
              return getProductFail({ erroMessage: product.message || '' });
            }

            return getProductSuccess({ data: product.data! });
          }),
        );
      }),
    );
  });

  getPrice$ = createEffect(() => {
    return this.actions.pipe(
      ofType(getPrice),
      mergeMap(({ productID }) => {
        return this.productConnector.getPrice(productID).pipe(
          map((product: GenericRequest<Price>) => {
            if (product.hasError) {
              return getPriceFail({ erroMessage: product.message || '' });
            }

            return getPriceSuccess({
              data: product.data!,
            });
          }),
        );
      }),
    );
  });

  getStock$ = createEffect(() => {
    return this.actions.pipe(
      ofType(getStock),
      mergeMap(({ productID }) => {
        return this.productConnector.getStock(productID).pipe(
          map((product: GenericRequest<GetStockResponse>) => {
            if (product.hasError) {
              return getStockFail({ erroMessage: product.message || '' });
            }

            return getStockSuccess({ data: product.data! });
          }),
        );
      }),
    );
  });
}
